import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>House of Canvas</h3>
          <p>East Africa's Premier Tent Manufacturer since 2010</p>
          <div className="social-links">
            <a href="https://facebook.com/houseofcanvas" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://instagram.com/houseofcanvas" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com/houseofcanvas" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/what-we-do">What We Do</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Tanzania Office</h4>
          <ul>
            <li><i className="fas fa-map-marker-alt"></i> Nelson Mandela Rd, Arusha, Tanzania</li>
            <li><i className="fas fa-phone"></i> +255 765 603 466</li>
            <li><i className="fas fa-envelope"></i> info@houseofcanvas.net</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Kenya Office</h4>
          <ul>
            <li><i className="fas fa-phone"></i> +254 110 279 065</li>
            <li><i className="fas fa-envelope"></i> infoke@houseofcanvas.net</li>
          </ul>
          <h4 className="mt-4">Business Hours</h4>
          <ul>
            <li>Monday - Friday: 8:00 AM - 5:00 PM</li>
            <li>Saturday: 8:00 AM - 1:00 PM</li>
            <li>Sunday: Closed</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} House of Canvas. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 